module.exports = __webpack_public_path__ + "media/img/payments/header-be080ddd9c5f91dc0edf4cc871a16d27.svg";